import { z } from "zod";

// Matches backend regex: ^\+?[1-9]\d{1,14}$ (E.164-ish)
const phoneRegex = /^\+?[1-9]\d{1,14}$/;

/** Password validation matching backend PasswordValidator requirements. */
export const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[A-Z]/, "Must contain an uppercase letter")
  .regex(/[a-z]/, "Must contain a lowercase letter")
  .regex(/\d/, "Must contain a number")
  .regex(/[!@#$%^&*()_+\-=\[\]{}';":"|,.<>\/?]/, "Must contain a special character");

/** Registration form schema matching backend RegisterRequest. */
export const registerSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  password: passwordSchema,
  phone: z.string().min(1, "Phone number is required").regex(phoneRegex, "Invalid phone format"),
});

export type RegisterFormValues = z.infer<typeof registerSchema>;

/** Reset password schema matching backend ResetPasswordRequest (email OTP or TOTP). */
export const resetPasswordSchema = z.object({
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  emailCode: z.string().length(6, "Code must be 6 digits").optional(),
  totpCode: z.string().length(6, "Code must be 6 digits").optional(),
  newPassword: passwordSchema,
}).refine((data) => data.emailCode || data.totpCode, {
  message: "Either email code or authenticator code is required",
  path: ["emailCode"],
});

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

/** TOTP code validation. */
export const totpCodeSchema = z.string().length(6, "Code must be 6 digits").regex(/^\d+$/, "Code must be digits only");
